<template>
    <div class="pr-5">
        <div class="field-frame">
            <h4 class="mt-4"><i class="fad has-text-primary fa-clipboard-list-check mr-3"></i>Study/Record Log</h4>
            <div class="pb-5"><i class="fal fa-info-circle mr-3"></i>This content block will display their study/record log. If used within an application you have the option to convert the minutes to units.</div>
            <b-switch class="mt-3" v-model="data.units">Display Unit Conversion (Applications Only)</b-switch>
        </div>
    </div>
</template>

<script>
    import {v4 as uuidv4} from 'uuid';

    export default {
        components: {},
        props: ['data'],
        data: function () {
            return {}
        },
        computed: {},
        methods: {},
        created() {
            if (!this.data.units) {
                this.data.title = "";
                this.data.units = false;
                this.data.id = uuidv4();
            }
        }
    };
</script>

<style lang="scss">
    .field-frame {
        border-radius: 5px;
        margin: 0 0 1rem 2rem;
    }
</style>
